import { LightShowOperation } from './lightshow-operation';
import { FlashTypes } from '../operation-types';
import { LightshowState } from '../lightshow-state';

export class SequenceOperation extends LightShowOperation {
    public orderedSections: [{order: number, section: string}];
    public spacing: number;

    constructor(position: number, duration: number, ignoreOverlap = false, uniqueId = Math.random().toString(36).slice(-5)) {
        super();
        this.position = position;
        this.color = 'white';
        this.flashType = FlashTypes.sparkleSteady;
        this.timelineColor = 'green';
        this.uniqueId = uniqueId;
        this.sectionList = [];
    }


    public toJson() {
      this.orderedSections.push({order: 1, section: '123'});
      this.orderedSections.sort((a, b) => a.order - b.order);
      const sequenceToFlashes = this.orderedSections.map((o, index) => ({
        type: FlashTypes.torchOn,
        duration: this.spacing / 1000,
        time: Math.round(this.position + this.spacing * index),
        section: o.section
      }));

      return sequenceToFlashes;
    }

    public tick(state: LightshowState) {

    }

    public end(state: LightshowState) {
      state.isFlashOn = false;
    }

    public wait() { }
}
